import { DemoComunityListObject } from "pages/files/CommunityListing";
import { Button } from "ui";
import { CustomComponentProps } from "utils/types/generalTypes";

export type CommunityRequestProps = CustomComponentProps & {
    listItem: DemoComunityListObject;
};

const CommunityRequest = ({
    listItem,
    className,
    style
}: CommunityRequestProps) => {
    return (
        <div
            className={`card community-list-request d-flex gap-5 flex-j-start flex-a-center w-full ${className}`}
            style={style}
        >
            <div className="text-container d-flex flex-j-start flex-a-center gap-5">
                <div className="community-list-request-img">
                    <img src={listItem.img} alt={listItem.id} />
                </div>
                <div className="text">
                    <h3 className="box-title mb-10">
                        <a href="/communities/@beerexperts">{listItem.title}</a>
                    </h3>
                    <p className="momeento-p">{listItem.about}</p>
                </div>
            </div>
            <div className="community-list-request-btns d-flex flex-j-center flex-a-center gap-5">
                <Button text="Decline" color="red-button" />
                <Button text="Accept" color="green-button" />
            </div>
        </div>
    );
};

export default CommunityRequest;
